/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class PossessedIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.0, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xWaysInfectious: true,
        xNudge: true,
        xBet: true,
        volatility: Volatility.EXTREME
    };

    logoSprite: PIXI.Sprite;
    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");

        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("feature3_US", "nolimit/screens/images/pageImage_2_US.png");
        imgLoader.add("feature4", "resources/images/intro_feature4.png");
        imgLoader.add("feature5", "resources/images/intro_feature5.png");
        imgLoader.add("feature6", "resources/images/intro_feature6.png");
        imgLoader.add("feature7", "resources/images/intro_feature7.png");
        imgLoader.add("feature8", "resources/images/intro_feature8.png");

        imgLoader.add(PossessedGameAssets.IMAGES_LOGO, PossessedGameAssets.IMAGES_LOGO);
        imgLoader.add(PossessedGameAssets.IMAGES_LOGO_FS, PossessedGameAssets.IMAGES_LOGO_FS);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onShow() {
        this.logo.parent.addChild(this.logo);
    }

    onResize() {
        if (NolimitApplication.isLandscape) {
            this.logo.scale.set(0.65, 0.65);
            this.logo.position.set(NolimitApplication.screenBounds.left / 2 + 67, 130);
            this.logo.visible = (NolimitApplication.screenBounds.left - 134) < (-this.logo.width);
        } else {
            this.logo.scale.set(1, 1);
            this.logo.position.set(360, NolimitApplication.screenBounds.top / 2);
            this.logo.visible = NolimitApplication.screenBounds.top < (-this.logo.height);
        }
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderTop.visible = false;

        this.borderBottom = new PIXI.Container();
        this.borderBottom.visible = false;


        this.logo = new PIXI.Container();
        this.logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(PossessedGameAssets.IMAGES_LOGO));
        this.logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(this.logoSprite);
        this.onResize();

        let featureSprites: PIXI.Sprite[] = [];
        for (let i = 1; i <= 8; i++) {
            const featureSprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature" + i));
            featureSprite.name = `feature${i}`;
            featureSprite.anchor.set(0.5, 0.5);
            featureSprites.push(featureSprite);
        }

        this.pages = [
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
        ];

        this.pages[0].addChild(featureSprites[0]);  // WinCap
        this.pages[1].addChild(featureSprites[1]);
        this.pages[2].addChild(featureSprites[2]);
        this.pages[3].addChild(featureSprites[3]);  // xBet
        this.pages[4].addChild(featureSprites[4]);
        this.pages[5].addChild(featureSprites[5]);
        this.pages[6].addChild(featureSprites[6]);
        this.pages[7].addChild(featureSprites[7]);

        if (Possessed.apiPlugin.gameClientConfiguration.isSet) {
            if (!Possessed.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                this.deletePage("feature4");
            }
            if (Possessed.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
                this.deletePage("feature1");
            }
            this.loadMultiplierImage();
        } else {
            Possessed.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (!Possessed.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                    this.deletePage("feature4");
                }
                if (Possessed.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
                    this.deletePage("feature1");
                }
                this.loadMultiplierImage();
            })
        }
    }

    private loadMultiplierImage(): void {
        if (!Possessed.apiPlugin.gameClientConfiguration.showMultipliersInfo) {
            for (let i: number = 0; i < this.pages.length; i++) {
                if (this.pages[i].children[0].name === "feature3") {
                    (<PIXI.Sprite>this.pages[i].children[0]).texture = ImgLoader.getImgTexture("feature3_US");
                }
            }
        }
    }

    private deletePage(featureName: string): void {
        for (let i: number = 0; i < this.pages.length; i++) {
            if (this.pages[i].children[0].name === featureName) {
                this.pages.splice(i, 1);
            }
        }
    }
}